import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postCreateReceiptCounter } from "apis";
import { getQueueConfigQueryKey } from "./get-queue-config";

const usePostCreateReceiptCounter = () => {
  const queryClient = useQueryClient();

  return useMutation(postCreateReceiptCounter, {
    onSuccess: () => {
      return queryClient.invalidateQueries(getQueueConfigQueryKey());
    },
  });
};

export default usePostCreateReceiptCounter;
